"use client"

import { useEffect, type ComponentProps } from "react"
import Link from "next/link"
import type { Idioma } from "@/lib/landing/idioma"

/**
 * El idioma de la web pública pasa al registro y al acceso por la cookie
 * NEXT_LOCALE, la que leen app/layout.tsx y el layout de (auth). Se apunta al
 * leer la web en inglés y al cambiar de idioma con el enlace ES/EN; leer la
 * web en castellano no la toca, para no cambiarle el idioma de la app a quien
 * la usa en inglés y entra a mirar la portada.
 */
export function apuntarIdioma(idioma: Idioma) {
  document.cookie = `NEXT_LOCALE=${idioma}; path=/; max-age=${60 * 60 * 24 * 365}; samesite=lax`
}

export function RecordarIngles() {
  useEffect(() => {
    if (!document.cookie.split("; ").includes("NEXT_LOCALE=en")) apuntarIdioma("en")
  }, [])
  return null
}

export function EnlaceDeIdioma({ a, ...props }: ComponentProps<typeof Link> & { a: Idioma }) {
  return (
    <Link
      {...props}
      hrefLang={a}
      onClick={(e) => {
        apuntarIdioma(a)
        props.onClick?.(e)
      }}
    />
  )
}
